<!--
    Component Self
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="container">
		<div id="content" class="content" v-if="cursor < 0">
			<div class="bar largeText">
				<div class="gridLabel bg-self">{{ model.getDictionary('nav_selection')}}</div>
			</div>

			<div v-if="list.length == 0" class='work-none'>{{ model.getDictionary('selection_empty')}}</div>
			
			<template v-else>
				<div class="work-grid" @touchstart="touchStartScroll($event)" @touchend="touchEndScroll($event)" @wheel.prevent="scroll($event.deltaY > 0? 1 : -1)">
					<div
						class="work-image zoomable link"
						v-for="(work, index) in list.slice(slice, slice + sliceSize)"
						:key="work.getID()"
					>
						<img
							v-if="work.getImages().isImage()"						
							class="link"
							:src="work.getImages().getImageURL(previewImageQuality)"
							:title="work.getArtistLabel() + ' - ' + work.getTitle() + ' (' + work.getYear() + ')'"
							@click="select(index + slice)"
						/>
						<div v-else 
							v-html="work.getImages().getMultiMediaHTML(0, 'preview')" 
							:title="work.getArtistLabel() + ' - ' + work.getTitle() + ' (' + work.getYear() + ')'"
							@click="select(index + slice)"></div>
					</div>

					<div
						class="work-grid-up arrow"
						v-if="slice > 0"
						@click.left="scroll(-1)"
						@mousedown.left="autoscroll('start', -1)"
						@mouseup.left="autoscroll('stop')"
					>&#x25B2;</div>
					<div
						class="work-grid-down arrow"
						v-if="slice < maxSlice"
						@click.left="scroll(1)"
						@mousedown.left="autoscroll('start', 1)"
						@mouseup.left="autoscroll('stop')"
					>&#x25BC;</div>
				</div>

				<div class='self-link'>
					<div class="bar largeText">
						<div class="gridLabel bg-self-light">{{ model.getDictionary('selection_share') }}</div>
					</div>
					<div class='self-link-content'><span id='linkContent'>{{ shareLink }}</span>

						<button @click.prevent="copy()">{{ model.getDictionary('selection_link') }}</button>
					</div>
				</div>
			</template>

		</div>

		<work-detail :list="list" :index="cursor"></work-detail>
	</div>
</template>

<script>

	import Vue from "vue";
	import { GRID_CELLS, GRID_COLUMNS } from "./../model/config.js";
	import { model } from "./../model/Model.js";
	import { ListWithCursor } from "./../mixin/ListWithCursor.js";
	import { Scrollable } from "./../mixin/Scrollable.js";
	import WorkDetail from "./WorkDetail.vue";

	export default {
		mixins: [ListWithCursor, Scrollable],
		components: { WorkDetail },

		data: function() {
			return {
				// expose the model for translations
				model: model,
				// source of the preview images
				previewImageQuality: 'small',
				// number of cells visible at once
				sliceSize: GRID_CELLS
			};
		},

		methods: {
			copy: function() {
				window.getSelection().selectAllChildren(document.getElementById('linkContent'));
				document.execCommand('copy');			
			}
		},

		// the active selection as a link
		computed: {
			shareLink: function() {
				let buffer = location.href;
				if (buffer.endsWith("?Self") == false) {
					buffer = buffer.substring(0, buffer.indexOf("?Self") + 5);			
				}
				buffer += "/";
				buffer += model.getSelection().getLink();
				return buffer;
			}
		},

		watch: {
			list: function() {
				this.maxSlice = Math.max(0, this.list.length - this.sliceSize);
				this.slice = Math.min(this.maxSlice, this.slice);
			}
		},

		created: function() {
			
			//http://localhost:8080/?Self/EFIKDFKDCKCDGKCFIKBBIKJBKDBBKCCJKDBGKGEKBDEK
			// parse url if available
			if (typeof this.args [0] !== "undefined" && this.args [0] != null && this.args [0] != '') {
				model.getSelection().parseLink(this.args [0]);
			}
			this.list = model.getSelection().getList();
			this.sliceSize = Vue.prototype.$device == 'large'? GRID_CELLS : 4;
			this.scrollBy =  Vue.prototype.$device == 'large'? GRID_COLUMNS : 2;
			this.maxSlice = Math.max(0, this.list.length - this.sliceSize);
			this.previewImageQuality = Vue.prototype.$previewImageQuality;
		}

	};

</script>


<style>

@media (min-width: 1000px) {

	div.self-link {
		margin-top: 3rem;
	}

	div.self-link-content {
		font-size: 1.4rem;
		margin: -3rem 0;
		padding: 1rem;
		border: 3px solid #c3cdd5;
		user-select: all;
		overflow: auto;
	}

	div.self-link-content span {
		user-select: all;
	}

	div.self-link-content button {
		display: block;
		font-size: 1.4rem;
		background-color: #586c7e;
		color: white;
		border: none;
		margin: 1rem 0 0.5rem 0;
		padding: 0.5rem 1rem;
		cursor: pointer;
	}

}

@media (max-width: 1000px) {

	div.self-link {
		display: none;
	}

}

</style>